import React, { createContext, useContext, useEffect, useState } from 'react';

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      const raw = localStorage.getItem('hos_cart');
      return raw ? JSON.parse(raw) : [];
    } catch { return []; }
  });
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem('hos_cart', JSON.stringify(items));
  }, [items]);

  const addItem = (product) => {
    const productId = product.id || product.productId;
    const variantId = product.variantId || 'default';
    const itemKey = `${productId}_${variantId}`;

    setItems(prev => {
      const exists = prev.find(p => (p.key || `${p.productId}_${p.variantId}`) === itemKey);
      if (exists) {
        return prev.map(p => (p.key || `${p.productId}_${p.variantId}`) === itemKey ? { ...p, qty: p.qty + 1, image: p.image || product.image } : p);
      }
      return [...prev, {
        key: itemKey,
        id: productId,
        productId,
        variantId,
        name: product.name,
        variantName: product.variantName || product.metalFinish || '',
        price: product.price,
        image: product.image,
        qty: 1
      }];
    });
    setIsOpen(true);
  };

  const removeItem = (keyOrId) => setItems(prev => prev.filter(p => p.key !== keyOrId && p.id !== keyOrId && p.productId !== keyOrId));
  const updateQty = (keyOrId, qty) => setItems(prev => prev.map(p => (p.key === keyOrId || p.id === keyOrId || p.productId === keyOrId) ? { ...p, qty: Math.max(1, qty) } : p));
  const subtotal = items.reduce((s, i) => s + i.price * i.qty, 0);
  const count = items.reduce((s, i) => s + i.qty, 0);

  return (
    <CartContext.Provider value={{ items, addItem, removeItem, updateQty, subtotal, count, isOpen, setIsOpen }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
